import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  IconButton,
} from '@chakra-ui/react';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { FaPlay } from 'react-icons/fa';
import CampaignListCustomModal from './CampaignListCustomModal';

const CampaignList = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [subjectLine, setSubjectLine] = useState('');
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const res = await axios.get(
          'https://bounce.mailamp.in/campaign/html/campaign',
        );
        console.log('🚀 ~ fetchCampaigns ~ res:', res);
        setCampaigns(res.data.data);
      } catch (error) {
        console.log('🚀 ~ fetchCampaigns ~ error:', error);
        const errorMessage =
          error.response?.data?.message || 'An error occurred';
        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchCampaigns();
  }, []);

  const handleViewCampaign = (campaignId) => {
    setSelectedCampaignId(campaignId);
    setIsOpen(true);
  };

  const handleSave = async () => {
    // Implement your save logic here
    try {
      const res = await axios.post(
        'https://bounce.mailamp.in/campaign/html/run',
        {
          campaignId: selectedCampaignId,
          subject: subjectLine,
        },
      );
      if (res.status === 200 || res.status === 201) {
        console.log('🚀 ~ res:', res);

        toast.success(res.data.message);
        setSubjectLine('');
        setIsOpen(false); // Close the modal only after successful save
      } else {
        throw new Error('Unexpected response status');
      }
    } catch (error) {
      console.log('🚀 ~ error:', error);
      toast.error('Failed to save the template. Please try again.');
      // Keep the modal open so the user can retry
    }
  };

  const onClose = () => {
    setSubjectLine('');
    setIsOpen(false);
  };

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Box mt={5} bg="white" p={4} borderRadius="lg" boxShadow="md">
        {loading ? (
          <Flex justify="center" align="center">
            <Spinner size="xl" />
          </Flex>
        ) : (
          <Table variant="simple">
            <Thead bgColor="#f4f4f4">
              <Tr>
                <Th>No.</Th>
                <Th>Campaign Name</Th>
                <Th>Date Created</Th>
                <Th>View Campaign</Th>
              </Tr>
            </Thead>
            <Tbody>
              {campaigns?.map((campaign, index) => (
                <Tr key={campaign._id}>
                  <Td>{index + 1}</Td>
                  <Td>{campaign.name}</Td>
                  <Td>{new Date(campaign.createDate).toLocaleDateString()}</Td>
                  <Td>
                    <IconButton
                      onClick={() => handleViewCampaign(campaign._id)}
                      aria-label="Run Campaign"
                      icon={<FaPlay />}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </Box>

      <CampaignListCustomModal
        isOpen={isOpen}
        onClose={onClose}
        subjectLine={subjectLine}
        setSubjectLine={setSubjectLine}
        handleSave={handleSave}
      />
    </Box>
  );
};

export default CampaignList;
